const release = '0.14.1'

module.exports = { release }



// WEBPACK FOOTER //
// ./release.js